<script setup lang="ts">
import { onMounted } from 'vue';
import { useRouter } from 'vue-router';
import { AdminRole, AdminRoleName, getRolePermissions } from '@/shared';
import { useAuthStore } from '@/stores/auth';
import { useMock } from '@/utils/request';

const auth = useAuthStore();
const router = useRouter();

const roles = Object.values(AdminRole).map((id) => ({
  id,
  name: AdminRoleName[id],
  permissions: getRolePermissions(id as AdminRole),
}));

const switchTo = (role: typeof roles[number]) => {
  if (!useMock) return;
  auth.switchRole({
    role: role.id,
    roleName: role.name,
    permissions: role.permissions,
  });
  router.push('/dashboard');
};

onMounted(() => {
  if (!useMock) router.replace('/dashboard');
});
</script>

<template>
  <div class="switch-role">
    <h2>角色切换</h2>
    <p class="hint">仅 Mock 演示环境可用；真实环境角色由管理员账号和服务端令牌决定。</p>
    <div class="role-grid">
      <div v-for="role in roles" :key="role.id" class="role-card" @click="switchTo(role)">
        <div class="role-name">{{ role.name }}</div>
        <div class="role-id">{{ role.id }}</div>
        <div class="role-perm-count">{{ role.permissions.length }} 个权限点</div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.switch-role { padding: 24px; }
.hint { color: #888; font-size: 14px; margin-bottom: 16px; }
.role-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));
  gap: 16px;
}
.role-card {
  padding: 20px;
  background: #fff;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.2s;
  border: 1px solid transparent;
}
.role-card:hover {
  border-color: var(--gyjk-primary);
  box-shadow: 0 4px 12px rgba(61, 167, 112, 0.15);
}
.role-name { font-size: 18px; font-weight: 600; color: #1a1a1a; }
.role-id { color: #888; font-size: 12px; margin-top: 4px; }
.role-perm-count { color: var(--gyjk-primary); font-size: 14px; margin-top: 8px; }
</style>
